import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { USER_CHANGE_PASSWORD } from "../../../enums/UrlPaths";

export default function PasswordChange() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleChangePassword = () => {
    navigate(USER_CHANGE_PASSWORD);
  };

  return (
    <Button
      variant="outlined"
      onClick={() => handleChangePassword()}
      data-testid="profile.settings.password-change.button"
    >
      {t("Change")}
    </Button>
  );
}
